export default {
  addRecord: {
    width: "s",
    component: () =>
      import(
        /* webpackChunkName: "warehouse_dialog" */ "@/mods/warehouse/humitureManage/dialog/AddRecord"
      ),
  },
};
